import { render } from "./ModalControl.vue?vue&type=template&id=72fe3768&scoped=true"
import script from "./ModalControl.vue?vue&type=script&lang=js"
export * from "./ModalControl.vue?vue&type=script&lang=js"

import "./ModalControl.vue?vue&type=style&index=0&id=72fe3768&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fe3768"]])

export default __exports__